<template>
  <v-container class="theme_background borderRadius">
    <v-row class="justify-space-around">
      <v-col class="text-center borderRadius lineHeight16 theme_surface_background ma-2">
        <p class="mb-2" :style="{ color: fob.observationPreset.spreadType.color }">
          {{ $t(`views.fobs.spread`) }}
        </p>
        <label class="bodyTextsSmall opacity67">{{ $t(`domain.enums.spreadType.${fob.observationPreset.spreadType.name}`) }}</label>
      </v-col>
      <v-col class="text-center borderRadius lineHeight16 theme_surface_background ma-2">
        <p class="mb-2">{{ $t(`views.fobs.spotting`) }}</p>
        <label class="bodyTextsSmall opacity67">
          {{ $t(`domain.enums.spottingType.${fob.observationPreset.spottingType.name}`) }}
        </label>
      </v-col>

      <v-col cols="12" class="bodyTexts">
        <p class="text-caption text-primary">{{ $t('domain.fields.createdAt') }}:</p>
        <p>{{ getDate }}</p>
        <p v-if="updatedBy">· {{ updatedBy }}</p>
      </v-col>

      <v-col cols="12" class="bodyTexts">
        <p class="text-caption text-primary">{{ $t('domain.fields.comment') }}:</p>
        <p>{{ fob.comment }}</p>
      </v-col>

      <v-col cols="10" class="bodyTexts py-1 pr-3">
        <p class="text-caption text-primary">{{ $t('domain.fields.coordinates') }}:</p>
        <p>
          {{ fob.latitude }},
          {{ fob.longitude }}
        </p>
      </v-col>
      <v-col cols="2" class="d-flex justify-center align-center">
        <v-icon @click="goToExtent()">mdi-map-marker</v-icon>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
// Frameworks Import
import { computed } from 'vue'

import { asyncComputed } from '@vueuse/core'

//import Karonte
import useView from '@tsyl/karonte/lib/composables/useView'
import type { Coordinates } from '@tsyl/karonte/lib/types/coordinates'

// Settings store import
import SettingsStore from '@/stores/settingsStore.ts'
const settings = SettingsStore()

import type { IncidentFob } from '@/types/Fobs'

const props = defineProps<{
  fob: IncidentFob
}>()

const { getReactiveView } = useView()

const getDate = computed(() => settings.formatStringDateTime(props.fob.created_at))

const view = getReactiveView()

// TODO: there is no FOB edition, neither updated_by field
const updatedBy = asyncComputed(async () => {
  return undefined
})

function goToExtent() {
  const coordinates: Coordinates = {
    latitude: props.fob.latitude as number,
    longitude: props.fob.longitude as number
  }

  view.value?.goTo(coordinates, 17)
}
</script>

<style></style>
